/**
 * Follow the visibility decision (display_panel) that the server recomputes on every read.
 * A departure, arrival or F.ETA card is true only on its own day, and a card hidden by job
 * title is judged against the card's owner rather than the viewer.
 * The Side Panel (todoSortingHandler) and the Task Board (todoFilterHandler) share this one
 * rule, so a card a member cannot see on their own panel never shows up on the team board.
 */
export const isTodoDisplayed = (item) => item.display_panel === true && item.status !== null;
